<script lang="ts">
  interface Props {
    class?: string;
  }

  let { class: className = "" }: Props = $props();
  
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  class={className}
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7.39922 19.5991L5.19922 17.3741L11.9992 10.5741L18.7992 17.3741L16.5992 19.5991L11.9992 14.9991L7.39922 19.5991ZM7.39922 12.8241L5.19922 10.6241L11.9992 3.79907L18.7992 10.6241L16.5992 12.8241L11.9992 8.22407L7.39922 12.8241Z"
    fill="currentColor" />
</svg>
